import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "646e090b-7991-43e0-a400-ca4198f79dc8",
  publicId: "2",
  name: "1D equations of acoustics",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
